import { sidenavLink } from '@nagel-types';
import { getIsDevelopmentMode } from '../../utils/environmentUtils';
import { CUSTOMER_COMMUNICATION_ROUTE, PLANNING_ROUTE, TRANSPORT_ROUTE } from '../consts/routesConsts';

export const sidenavLinks: sidenavLink[] = [
    {
        icon: 'planning_icon',
        label: $localize`Planning`,
        route: PLANNING_ROUTE
    },
    {
        icon: 'lorry_icon',
        label: $localize`Transport orders`,
        route: TRANSPORT_ROUTE
    },
    {
        icon: 'envelope_icon',
        label: $localize`Customer communication`,
        route: CUSTOMER_COMMUNICATION_ROUTE
    },
    ...(getIsDevelopmentMode() ? [{
        icon: 'lorry_icon',
        label: 'Test',
        route: 'test'
    }] : [])
];